import blogReducer from "./blog/reducer";
import filtersReducer from "./filters/reducer"
import { combineReducers } from "redux";

const rootReducer = combineReducers({
    blog: blogReducer,
    filters: filtersReducer
});

export default rootReducer;